import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'

export const getReceiptById = async (app, receipt_id) => {
    let receipt = null

    app.startLoadingIndicator()
    await trackPromise (
        axios.get(app.API_URI + `/receipts?receipt_id=${receipt_id}`)
        .then(result => {
            receipt = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return receipt
}

export const getReceiptsList = async (app, filter) => {
    let receipts = null

    app.startLoadingIndicator()
    if (filter) {
        const { date } = filter
        await trackPromise (
            axios.get(app.API_URI + `/receipts/filter?dc_from=${date.date_created_from}&dc_to=${date.date_created_to}`)
            .then(async (result) => {
                receipts = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    } else {
        await trackPromise (
            axios.get(app.API_URI + '/receipts')
            .then(async (result) => {
                receipts = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return receipts
}

export const saveReceipt = async (app, receipt, silent=false) => {
    let save_receipt = null

    receipt.signed_in = app.client.signed_in
    receipt.receipt_for.item_id = (receipt.receipt_for.item_name === 'Invoice')

    ? receipt.receipt_for.item._id
    : {
        customer_account_id: receipt.receipt_for.item._id,
        credit_account_number: receipt.receipt_for.item.credit_accounts[receipt.receipt_for.item.credit_accounts.length - 1].credit_account_number
    }

    delete receipt.receipt_for.item

    if (!silent) app.startLoadingIndicator("Saving Receipt")

    /** New receipt */
    if (!receipt._id)
        await trackPromise (
            axios.post(app.API_URI + '/receipts', receipt)
            .then(result => {
                save_receipt = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    /** Update receipt */
    else
        await trackPromise (
            axios.put(app.API_URI + `/receipts?receipt_id=${receipt._id}`, receipt)
            .then(result => {
                save_receipt = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    return save_receipt
}

export const deleteReceipt = async (app, receipt) => {
    let delete_receipt = null

    app.startLoadingIndicator("Deleting Receipt")
    await trackPromise (
        axios.delete(app.API_URI + `/receipts?receipt_id=${receipt._id}&receipt_for=${receipt.receipt_for.item_name}&receipt_for_id=${receipt.receipt_for.item_id}`)
        .then(result => {
            delete_receipt = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return delete_receipt 
}

export const getReceiptsListSettings = async (app) => {
    let receipts_list_settings = null
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id

    app.startLoadingIndicator()
    await trackPromise (
        axios.get(app.API_URI + `/settings?user_id=${user_id}&field=receipts_list`)
        .then(result => {
            receipts_list_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return receipts_list_settings
}

export const saveReceiptsListSettings = async (app, settings) => {
    let save_receipt_list_settings = null 
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator("Saving settings")
    await trackPromise (
        axios.put(app.API_URI + `/settings?user_id=${user_id}&field=receipts_list`, settings)
        .then(result => {
            save_receipt_list_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return save_receipt_list_settings 
}